import { ShippingCondition } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-condition';
import {
  LOAD,
  LOAD_COMPLETE,
  LOAD_INITIAL_STATE,
  RESET,
  SET,
  SET_DIRECT,
  ShippingConditionsActions,
} from '../../actions/shipping-condition.actions';

export interface ShippingConditionsState {
  loaded: boolean;
  loading: boolean;
  shippingConditions: ShippingCondition[];
  selected: ShippingCondition;
}

export const initialState: ShippingConditionsState = {
  loaded: false,
  loading: false,
  shippingConditions: [],
  selected: null,
};

export function shippingConditionsReducer(
  state = initialState,
  action: ShippingConditionsActions,
): ShippingConditionsState {
  switch (action.type) {
    case LOAD_INITIAL_STATE: {
      return initialState as ShippingConditionsState;
    }
    case LOAD: {
      return {
        ...state,
        loading: true,
      } as ShippingConditionsState;
    }
    case LOAD_COMPLETE: {
      const shippingConditions: ShippingCondition[] = action.payload.shippingConditions;
      return {
        loaded: true,
        loading: false,
        shippingConditions: shippingConditions,
        selected: null,
      } as ShippingConditionsState;
    }
    case SET: {
      const selectedShippingCondition: ShippingCondition = state.shippingConditions.find(
        (shipCond: ShippingCondition) => shipCond.shippingConditionId === action.payload,
      );
      return {
        ...state,
        selected: selectedShippingCondition,
      } as ShippingConditionsState;
    }
    case SET_DIRECT: {
      return {
        ...state,
        selected: action.payload,
      } as ShippingConditionsState;
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
